import _ from 'lodash';

function scrollToId(domId) {
  let inIframe = false;

  try {
    inIframe = window.self !== window.top;
  } catch (e) {
    inIframe =  true;
  }

  let elementTop = document.getElementById(domId).getBoundingClientRect().top;

  if(inIframe) {
    window.parent.postMessage({type: "scrollTo", positionToScrollTo: elementTop}, '*');
  }
  else {
    window.scrollTo({ top: elementTop, behavior: "smooth" });
  }
}

export default {
  scrollToId
}